.list {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lYWxzVmlldy5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmxpc3RcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LWZsb3c6IHJvdyB3cmFwXG4gIGp1c3RpZnktY29udGVudDogY2VudGVyXG4iXX0= */